var map = {
	"./about": 5484,
	"./about.js": 5484,
	"./mag_man": 2905,
	"./mag_man.js": 2905,
	"./modals/adm_usr_histo": 8079,
	"./modals/adm_usr_histo.js": 8079,
	"./modals/mag_man_add": 5188,
	"./modals/mag_man_add.js": 5188,
	"./modals/mag_man_info": 8482,
	"./modals/mag_man_info.js": 8482,
	"./modals/mag_man_info_abo": 5538,
	"./modals/mag_man_info_abo.js": 5538,
	"./modals/mag_man_info_usr": 3344,
	"./modals/mag_man_info_usr.js": 3344,
	"./modals/mag_prm_logo": 8324,
	"./modals/mag_prm_logo.js": 8324,
	"./modals/usr_man_add": 1291,
	"./modals/usr_man_add.js": 1291,
	"./modals/usr_man_mags": 3322,
	"./modals/usr_man_mags.js": 3322,
	"./usr_man": 147,
	"./usr_man.js": 147,
	"./usr_ses": 9833,
	"./usr_ses.js": 9833
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 940;